const React = require("react");
const {View, Text} = require("@react-pdf/renderer");

const styles = require("../../styles/");

module.exports = ({title, value, hideValue}) => {
  const valueArr = Array.isArray(value)
    ? value
    : !!value
      ? [value]
      : ['-'];

  return (
    <View style={styles.sectionItem}>
      {title && (
        <Text style={styles.sectionItemTitle}>
          {title}
        </Text>
      )}
      {!hideValue && valueArr.map((text, id) => (
        <Text key={id} style={styles.sectionItemText}>
          {text}
        </Text>
      ))}
    </View>
  )
}
